export const scrollToMiddle = (parent: HTMLElement, child: HTMLElement) => {
  if (parent) {
    parent.scrollTo({
      left: child.offsetLeft - parent.clientWidth / 2 + child.clientWidth / 2,
      behavior: 'smooth',
    });
  }
};
